import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Code = createReactComponent("Code", ["svg", defaultAttributes, [["polyline", {
  points: "16 18 22 12 16 6",
  key: "t8aahb"
}], ["polyline", {
  points: "8 6 2 12 8 18",
  key: "15ak9b"
}]]]);
export default Code;